Vue.asyncComponent('cms-set-homepage', {
    data() {
        return {
            currentIsHome: false,
        }
    },
    methods: {
        async setHomepage() {
            const currentUrl = window.location.pathname + window.location.search + window.location.hash;

            const result = await this.$post(this.$getSetting('paths.baseCms') + '/user/set-homepage', {
                url: currentUrl
            });

            if (result.success) {
                this.$actionHandler.handle(result.todos, this);
                this.currentIsHome = true;
                this.$emit('set');
            }
        },
        async getHomepage() {
            const result = await this.$get(this.$getSetting('paths.baseCms') + '/user/get-homepage')

            if (result.success) {
                const currentUrl = result.currentHome;
                const currentFullUrl = (window.location.protocol + '//' + window.location.host + currentUrl);
                const locationUrl = window.location.href.indexOf('?t=') !== -1
                        ? window.location.href.substring(0, window.location.href.indexOf('?t='))
                        : window.location.href;
                this.currentIsHome = currentFullUrl === locationUrl;
            }
        }
    },
    watch: {
        "$route": {
            async handler($route, $oldRoute) {
               this.getHomepage();
            },
            deep: true
        }
    },
    async mounted() {
        this.getHomepage();
    }
}, 'cms/account/cms-set-homepage.html');